import lib from './../../js-lib/lib.js';

const Fonts = {
    render: (state) => {
        if(state.eco.current == 'disabled') {
            if(!lib.id('google-font')) {
                lib.stylesheet.add('https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,400;0,700;1,400;1,700&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&display=swap', 'google-font');
            }
        } else {
            lib.stylesheet.remove('google-font');
        }
    }
}

export { Fonts as default }